module.exports = __webpack_public_path__ + "img/full3-min.ab6ad716.png";